import { useEffect, useState } from "react";
import axios from "axios";
import TableView2 from "./TableView2"; // Optional if you want table preview for zone config

export default function EditDashboard({ onBackToDashboard, handleLogout }) {
  const [config, setConfig] = useState(null);
  const [zoneData, setZoneData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("basic");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const configResponse = await axios.get(
          process.env.REACT_APP_API_URL + "/api/config",
          { headers }
        );
        setConfig(configResponse.data);

        const zoneResponse = await axios.get(
          process.env.REACT_APP_API_URL + "/api/config/zones",
          { headers }
        );
        setZoneData(zoneResponse.data);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    let timeout;
    if (error === "Failed to authenticate token.") {
      timeout = setTimeout(() => handleLogout(), 3000);
    }
    return () => clearTimeout(timeout);
  }, [error, handleLogout]);

  const handleConfigChange = (e) => {
    const { name, value } = e.target;
    setConfig((prev) => ({ ...prev, [name]: value }));
  };

  const handleZoneChange = (index, field, value) => {
    const updatedZones = [...zoneData];
    if (field === "construction" || field === "marketingMultiplier") {
      updatedZones[index][field] = Number(value);
      if (field === "marketingMultiplier") {
        updatedZones[index].marketing = `${(Number(value) * 100).toFixed(1)}%`;
      }
    } else {
      updatedZones[index][field] = value;
    }
    setZoneData(updatedZones);
  };

  const handleSaveConfig = async () => {
    setSaving(true);
    setError("");
    try {
      const token = localStorage.getItem("token");
      await axios.post(process.env.REACT_APP_API_URL + "/api/config", config, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      alert("Basic Configuration updated!");
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveZones = async () => {
    setSaving(true);
    setError("");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        process.env.REACT_APP_API_URL + "/api/config/zones",
        zoneData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Zone Configuration updated!");
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <main className="main">
        <div className="topbar">
          <div className="topbar__brand">
            <span className="crumbs">Edit Dashboard</span>
          </div>
        </div>
        <div className="content">
          <section className="card">
            <header className="card__head">
              <div className="card__title">Loading Configuration...</div>
            </header>
          </section>
        </div>
      </main>
    );

  if (error)
    return (
      <main className="main">
        <div className="topbar">
          <div className="topbar__brand">
            <span className="crumbs">Edit Dashboard</span>
          </div>
        </div>
        <div className="content">
          <section className="card">
            <header className="card__head">
              <div className="card__title">Error: {error}</div>
            </header>
            {/* <div className="cta">
              <button className="btn-primary" onClick={onBackToDashboard}>
                ← Back to Dashboard
              </button>
            </div> */}
          </section>
        </div>
      </main>
    );

  return (
    <main className="main">
      <div className="topbar">
        <div className="topbar__brand">
          <span className="crumbs">Edit Dashboard</span>
        </div>
      </div>

      <div className="content">
        <section className="card">
          <header className="card__head">
            <div className="card__title">⚙️ Configuration Editor</div>
          </header>

          <div className="tabs-container-edit">
            <div className="tabs-edit">
              <button
                className={`tab-btn-edit ${
                  activeTab === "basic" ? "active" : ""
                }`}
                onClick={() => setActiveTab("basic")}
              >
                Basic Settings
              </button>
              <button
                className={`tab-btn-edit ${
                  activeTab === "zones" ? "active" : ""
                }`}
                onClick={() => setActiveTab("zones")}
              >
                Zone Settings
              </button>
              <div
                className="tab-indicator-edit"
                style={{
                  transform:
                    activeTab === "basic"
                      ? "translateX(0%)"
                      : "translateX(100%)",
                }}
              />
            </div>
          </div>

          {/* Basic Settings */}
          {activeTab === "basic" && config && (
            <>
              <div className="form">
                {Object.keys(config).map((key) => (
                  <div className="field" key={key}>
                    <label className="label">{key}</label>
                    <input
                      className="input"
                      type="number"
                      step="0.001"
                      name={key}
                      value={config[key]}
                      onChange={handleConfigChange}
                    />
                  </div>
                ))}
              </div>
              <div className="cta">
                <button
                  className="btn-primary"
                  onClick={handleSaveConfig}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "💾 Save Basic Config"}
                </button>
              </div>
            </>
          )}

          {/* Zone Settings */}
          {activeTab === "zones" && (
            <>
              <div className="form">
                {zoneData.map((zone, index) => (
                  <div className="card zone-card" key={zone.zone}>
                    <header className="card__head">
                      <div className="card__title">{zone.zone}</div>
                    </header>
                    <div className="field">
                      <label className="label">Construction Cost</label>
                      <input
                        className="input"
                        type="number"
                        value={zone.construction}
                        onChange={(e) =>
                          handleZoneChange(
                            index,
                            "construction",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="field">
                      <label className="label">Marketing Multiplier</label>
                      <input
                        className="input"
                        type="number"
                        step="0.001"
                        value={zone.marketingMultiplier}
                        onChange={(e) =>
                          handleZoneChange(
                            index,
                            "marketingMultiplier",
                            e.target.value
                          )
                        }
                      />
                      <small>Current: {zone.marketing}</small>
                    </div>
                  </div>
                ))}
              </div>
              <div className="cta">
                <button
                  className="btn-primary"
                  onClick={handleSaveZones}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "💾 Save Zone Config"}
                </button>
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
}
